import React from 'react'
import axios from 'axios'
import {
  Button, Card, Modal, Col, Form, Icon,Input,Row,
  Table, TimePicker, DatePicker, Switch, Cascader,
  notification, InputNumber,Avatar,Divider
} from 'antd'
import MyFancyComponent from './Map'
import moment from 'moment';
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {fetchOrders} from 'appRedux/actions/Orders'

const FormItem = Form.Item
const AUTH_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8'
function currencyFormat(num){
  return '¢' + num.toFixed(2)//.replace(/(\d)(?=(\d{4})+(?!\d))/g, '$1,')
}
function schedule(days_collection){
  var days='';
var array=days_collection.split(',')
    let orderDecode = [];
    orderDecode = array.map( (orders)=> {


    if(orders=='L'){
      days='lunes,'
       days.concat(days)
       
    }
      if(orders=='V'){
        
        days='Viernes'
         days.concat(days)
    }
      if(orders=='K'){
       
        days='Martes,'
         days.concat(days)
    }
      if(orders=='M'){
      
        days='Miercoles,'
         days.concat(days)
    }

      if(orders=='J'){
        days='Jueves,'
         days.concat(days)
    }
    
     console.log(days)
     return days;
    })
}

class Basic extends React.Component {

  state = {
    visible: false,
    id: '',
    name: '',
    total: '',
    price:'',
    result:[],
    url_image_user:'',
    latitude:'',
    longitude:'',
    taxes:'',
    shipping:'',
    subtotal:'',
    days_of_collection:'',
    recolecction_schedule:''

  }  

  showdetails = id => {
    axios({
      method: 'get',
      url: `https://admingreenerapp.crsostenible.com/api/public/api/app/history/order/detail/${id}`,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AUTH_TOKEN
      }
    })
    //.then(request => console.log(request.data))
  .then((request) => {this.setState({result: request.data.data,url_image_user:request.data.user_image,taxes:request.data.taxes,
    shipping:request.data.shipping,subtotal:request.data.subtotal})
  })
  .catch(error => alert(error.message))
  }


  showModal = () => {
    this.setState({
      visible: true,
      id: this.props.recording.id,
      price:this.props.recording.price,
      name: this.props.recording.name,
      total: this.props.recording.total,
      url_image_user:this.props.recording.user_image,
      latitude:this.props.recording.latitude,
      longitude:this.props.recording.longitude,
      phone:this.props.recording.phone,
      email:this.props.recording.email,
      shipping:this.props.recording.shipping,
      taxes:this.props.recording.taxes,
      subtotal:this.props.recording.subtotal,
      days_of_collection:this.props.days_of_collection,
      address_description:this.props.address_description
      //recolecction_schedule:schedule(this.props.days_of_collection)
    })

    console.log('state--',this.state);
  }
  recollectionSchedule=(dias)=>{

    var days='';
    console.log('hello',dias)
      let orderDecode = [];
      orderDecode = dias.map( (orders)=> {
  
  
      if(orders=='L'){
        days='lunes,'
         days.concat(days)
         
      }
        if(orders=='V'){
          
          days='Viernes'
           days.concat(days)
      }
        if(orders=='K'){
         
          days='Martes,'
           days.concat(days)
      }
        if(orders=='M'){
        
          days='Miercoles,'
           days.concat(days)
      }
  
        if(orders=='J'){
          days='Jueves,'
           days.concat(days)
      }
      
       console.log(days)
      })
    }
    
  handleCancel = e => {
    this.setState({
      id: '',
      name: '',
      price:'',
      total: '',
      url_image_user:'',
      taxes:'',
      shipping:'',
      subtotal:'',
      days_of_collection:'',
      description_direction:''
    })
    this.props.fetchOrders(this.props.dataState)
    this.setState({visible: false})
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'El producto se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al cambiar el producto.',
      })
    }
  }

                  
  //{  days.forEach(function(item){ 
   // <p>item<br></br></p>
  //})}


  render() {
    const columns = [
      {
        title: 'Nombre del producto',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Precio',
        dataIndex: 'price',
        key: 'price',
      },
      
      {
        title: 'Cantidad',
        dataIndex: 'quantity',
        key: 'quantity',
      },

      {
        title: 'Subtotal',
        dataIndex: 'subtotal',
        key: 'subtotal',
      },
    ]


    
    let days =this.props.recording.days_of_collection.split(" ")
     
      console.log(days)
  
   
    return (


      <div>
        <Button type="primary" onClick={ () => {
        this.showModal()
        this.showdetails(this.props.recording.id)
        console.log(this.props)
        console.log('my state',this.props.recording.address_description)
        }}>
        Ver detalles
        </Button>
        <Modal
         okText="Regresar"
          title=""
          visible={this.state.visible}
          onOk={this.handleCancel}
          //onCancel={this.handleCancel}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Card className="gx-card" title="Información sobre el pedido">
          <Row>
      <Col span={8}>

      <div className="gx-login-header">
            <Avatar shape="circle" className="gx-size-80" src={this.state.url_image_user}/>

            </div>
      </Col>
      <Col span={8}>
      <div lg={12} md={12} sm={12} xs={12} style={{position: 'relative', top: '20px',right: '34px'}}><p>{this.props.recording.name}</p></div>      
      <div lg={12} md={12} sm={12} xs={12} style={{position: 'relative', top: '20px',right: '34px'}}><p><i className="icon icon-chat"/> {this.props.recording.phone}</p></div>     </Col>

      <Col span={8}>

 
      <p style={{position: 'relative', top: '20px',right: '34px', color:'#F52D56',fontWeight:'bold'}}>Pedido #{this.props.recording.id}</p>
      <p style={{position: 'relative', top: '20px',right: '34px'}}><i className="icon icon-email"/> {this.props.recording.email}</p>

      </Col>
    </Row>
          <br></br>
            <Row className="">
                    <div style={{height:'400px',width:'451px'}}>
                    <MyFancyComponent latitude = {this.state.longitude} longitude={this.state.latitude} address_description={this.props.recording.address_description}/>

                    </div>
                  
                
              </Row>
          </Card>

          <Card className="gx-card" title="SEÑAS DE UBICACIÓN"  style={{backgroundColor:'#EFEFF4'}}>
              <Row className="">

                  <Col lg={24} md={24} sm={24} xs={24} style={{backgroundColor:'#EFEFF4'}}>
                  
                    <p>{this.props.recording.location}</p>

                  </Col>
            </Row>
        </Card>

        
          <Card className="gx-card" title="DÍAS DE RECOLECCIÓN"  style={{backgroundColor:'#EFEFF4'}}>
              <Row className="">

                  <Col lg={24} md={24} sm={24} xs={24} style={{backgroundColor:'#EFEFF4'}}>
                  
      <p>{this.props.recording.days_of_collection}</p>

  


                    
                  </Col>
            </Row>
        </Card>

          <Card className="gx-card" title="Resumen del pedido">
            <form>
              <Row>
              <Col lg={24} md={24} sm={24} xs={24}>
                  <Table
                    className="gx-table-responsive"
                    columns={columns}
                    dataSource={this.state.result}
                    size="middle" 
                  />
                </Col>
                </Row>
                <Row className="padding-modal">
                <Col lg={24} md={24} sm={24} xs={24}>
                  <FormItem
                  >

                    <table>
                      <tr><td style={{width: '350px'}}>SUBTOTAL:</td><td>¢{this.state.subtotal}</td></tr>
                      <tr><td style={{width: '350px'}}>TRANSPORTE:</td><td>¢{this.state.shipping}</td></tr>
                      <tr><td style={{width: '350px'}}>IMPUESTOS:</td><td>¢{this.state.taxes}</td></tr>
                    </table>
                    <Divider/>
                    
                    

                    <table>
                       <tr><td style={{width: '350px' ,fontWeight:'bold'}}>TOTAL:</td><td style={{fontWeight:'bold'}}>{this.props.recording.total}</td></tr>
                    </table>
                  </FormItem>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, orders}) {
  return {
    placeStores,
    orders,
  }
}
export default connect(
  mapStateToProps,
  {fetchOrders},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Orders/Details.js